import { AxiosRequest } from "../ApiCall";
import { configEnv } from "../constant";
import {
    NotificationSeverity,
    NotificationCategory,
    NotificationPriority,
} from "../../utils/toast";

export interface NotificationListParams {
    from?: string;
    to?: string;
}

export interface NotificationSummary {
    totalUnread: number;
    taskUnread: number;
    auditUnread: number;
}

export interface MarkNotificationsReadBody {
    organization?: string;
    category?: string;
}

export const notificationsApi = {
    createNotification: async (
        body: {
            title: string;
            message: string;
            severity: NotificationSeverity;
            category: NotificationCategory;
            user: string;
            link?: string;
            priority?: NotificationPriority;
            data?: any;
            expiresAt?: Date;
        },
        header: any
    ) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/notifications`,
                body,
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
    getNotificationsByUser: async (
        userId: string,
        header: any,
        params?: NotificationListParams
    ) => {
        try {
            const searchParams = new URLSearchParams();
            if (params?.from) searchParams.set("from", params.from);
            if (params?.to) searchParams.set("to", params.to);
            const query = searchParams.toString();
            const url = `${configEnv.baseUrl}/notifications/user/${userId}${
                query ? `?${query}` : ""
            }`;
            const data = await AxiosRequest("GET", url, null, header);
            return data.data;
        } catch (error: any) {
        }
    },
    getNotificationSummary: async (
        userId: string,
        header: any,
        organization?: string
    ) => {
        try {
            const searchParams = new URLSearchParams();
            if (organization) searchParams.set("organization", organization);
            const query = searchParams.toString();
            const url = `${configEnv.baseUrl}/notifications/user/${userId}/summary${
                query ? `?${query}` : ""
            }`;
            const data = await AxiosRequest("GET", url, null, header);
            return data.data;
        } catch (error: any) {
        }
    },
    markNotificationsRead: async (
        userId: string,
        header: any,
        body: MarkNotificationsReadBody
    ) => {
        try {
            const data = await AxiosRequest(
                "PATCH",
                `${configEnv.baseUrl}/notifications/user/${userId}/mark-read`,
                body,
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
    updateNotification: async (
        id: string,
        body: {
            title?: string;
            message?: string;
            severity?: NotificationSeverity;
            category?: NotificationCategory;
            read?: boolean;
            link?: string;
            priority?: NotificationPriority;
            data?: any;
            expiresAt?: Date;
        },
        header: any
    ) => {
        try {
            const data = await AxiosRequest(
                "PUT",
                `${configEnv.baseUrl}/notifications/${id}`,
                body,
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
    deleteNotification: async (id: string, header: any) => {
        try {
            const data = await AxiosRequest(
                "DELETE",
                `${configEnv.baseUrl}/notifications/${id}`,
                null,
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
};
